import { Link } from 'gatsby';
import styled from 'styled-components';

const NavLink = styled(Link)`
  display: block;
  color: ${({ theme }) => theme.pages.coverNav.linkColor};
  text-decoration: none;
  padding: ${({ theme }) => theme.pages.coverNav.linkPadding};
  &:hover,
  &.${({ activeClassName }) => activeClassName} {
    color: ${({ theme }) => theme.pages.coverNav.linkColorHover};
    background-color: ${({ theme }) => theme.pages.coverNav.linkBackgroundColorHover};
  }
`;

export default NavLink;
